import confetti from "canvas-confetti";

type Origin = { x: number; y: number };

const DEFAULT_COLORS = [
	"#2563eb",
	"#60a5fa",
	"#ffffff",
	"#0ea5e9",
	"#f8fafc",
	"#1e3a8a",
];

const GOLDEN_COLORS = [
	"#FFD700",
	"#FFC800",
	"#FFA500",
	"#FFDF00",
	"#F4C430",
	"#FFF3B0",
];

export function fireConfetti(options?: { origin?: Origin }) {
	if (typeof window === "undefined") return;
	const origin = options?.origin ?? { x: 0.5, y: 0.7 };
	confetti({
		particleCount: 90,
		spread: 70,
		startVelocity: 45,
		ticks: 220,
		origin,
		colors: DEFAULT_COLORS,
		scalar: 0.9,
		zIndex: 1000,
	});
	confetti({
		particleCount: 40,
		spread: 120,
		startVelocity: 30,
		ticks: 260,
		origin,
		colors: DEFAULT_COLORS,
		scalar: 0.7,
		zIndex: 1000,
	});
}

export function fireGoldenConfetti(options?: { origin?: Origin }) {
	if (typeof window === "undefined") return;
	const origin = options?.origin ?? { x: 0.5, y: 0.6 };

	confetti({
		particleCount: 160,
		spread: 90,
		startVelocity: 55,
		ticks: 280,
		origin,
		colors: GOLDEN_COLORS,
		scalar: 1.1,
		zIndex: 1000,
	});
	confetti({
		particleCount: 80,
		spread: 140,
		startVelocity: 35,
		ticks: 320,
		origin,
		colors: GOLDEN_COLORS,
		scalar: 0.9,
		zIndex: 1000,
		shapes: ["star", "circle"],
	});

	window.setTimeout(() => {
		confetti({
			particleCount: 60,
			angle: 60,
			spread: 70,
			startVelocity: 50,
			origin: { x: 0, y: 0.8 },
			colors: GOLDEN_COLORS,
			scalar: 1,
			zIndex: 1000,
		});
		confetti({
			particleCount: 60,
			angle: 120,
			spread: 70,
			startVelocity: 50,
			origin: { x: 1, y: 0.8 },
			colors: GOLDEN_COLORS,
			scalar: 1,
			zIndex: 1000,
		});
	}, 180);
}
